import AdminRouterContainer from './container'
export default AdminRouterContainer
